/**
 * 资源管理相关
 */
import axios from "../../utils/axios";

// 余额查询接口
export function balance(data) {
    return axios({
        url: "/admin/fund/balance/index",
        method: "post",
        data: data
    });
}

// 添加充值请求（用户使用）
export function charge_request(data) {
    return axios({
        url: "/admin/fund/charge/request",
        method: "post",
        data: data
    });
}

// 获取自己的充值请求记录
export function my_request_list(data) {
    return axios({
        url: "/admin/fund/charge/my_request_list",
        method: "post",
        data: data
    });
}

// 查看充值请求的图片
export function evidence_image(data) {
    return axios({
        url: "/index/evidence/image",
        method: "post",
        data: data
    });
}

// 获得用户的充值请求记录
export function admin_request_list(data) {
    return axios({
        url: "/admin/fund/charge/admin_request_list",
        method: "post",
        data: data
    });
}

// 为用户充值
export function charge_index(data) {
    return axios({
        url: "/admin/fund/charge/index",
        method: "post",
        data: data
    });
}

// 将请求改为已处理状态
export function process_request(data) {
    return axios({
        url: "/admin/fund/charge/process_request",
        method: "post",
        data: data
    });
}

// 查看自己的充值记录
export function charge_record(data) {
    return axios({
        url: "/admin/fund/charge/record",
        method: "post",
        data: data
    });
}

// 查看用户的充值记录
export function admin_record(data) {
    return axios({
        url: "/admin/fund/charge/admin_record",
        method: "post",
        data: data
    });
}
